import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { dataNeededQueryKey } from "../decisioning.keys";

const parseDataNeeded = (data: unknown) =>
	Dtos.Decisioning.DataNeeded.Get.Response.schema.array().parse(data);

export const useFetchAdminDataNeeded = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: dataNeededQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			parseDataNeeded(await get<unknown>(`/v2/admin/surety/accounts/${accountId}/data-needed`)),
	});

	return {
		dataNeeded: query.data,
		dataNeededIsLoading: query.isLoading,
		dataNeededError: query.error,
		refetchDataNeeded: query.refetch,
	};
};
